/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const starknet_chain_about = () => `Starknet stands as a permissionless blockchain solution, functioning as a Validity-Rollup, often referred to as a zero-knowledge rollup (ZK rollup) for Ethereum. It's a Layer 2 (L2) platform that empowers dApps to achieve significant computational scalability while upholding Ethereum's inherent composability and security standards.`
